module.exports = __webpack_public_path__ + "static/media/Green_tick.5fe9fd5d.png";